import { useEffect, useMemo } from 'react';
import { tracking, experiment } from '@podiumhq/tracking';

import isQABot from '../../lib/isQABot';
import env from '../../lib/env';
import { useFetchCurrentUser } from '../../api/users/queries';
import ADMIN_TRACKING_EVENTS from './trackingEvents';

const events = {
  ...ADMIN_TRACKING_EVENTS,
};

// Pass enabled: true if you want to use Amplitude feature flags
function setupTracking({ enabled, user }) {
  tracking.init({
    enabled,
    events,
    debug: true,
    amplitudeToken: env.REACT_APP_AMP_TOKEN,
    amplitudeConfig: {
      plan: {
        version: env.REACT_APP_VERSION,
      },
    },
  });

  const userProperties = {
    'Role Level': user.role,
    App: 'Admin',
  };

  tracking.setUserUid(user.uid);
  tracking.setUserProperties(userProperties);

  if (env.REACT_APP_AMP_EXPERIMENT_TOKEN) {
    experiment.init({
      connectToAnalytics: true,
      enabled: true,
      debug: false,
      environmentKey: env.REACT_APP_AMP_EXPERIMENT_TOKEN,
      experimentUser: {
        user_id: user.uid,
        user_properties: userProperties,
      },
    });
  }
}

function AmplitudeTracking() {
  const shouldTrackUser = useMemo(() => {
    return process.env.NODE_ENV === 'production' && !isQABot();
  }, []);

  const { currentUser, loadingCurrentUser: currentUserLoading } =
    useFetchCurrentUser();

  useEffect(
    () => {
      if (currentUser && !currentUserLoading) {
        setupTracking({ enabled: shouldTrackUser, user: currentUser });
      }
    }, // Fix this the next time the file is edited
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentUser, currentUserLoading]
  );

  return null;
}

export default AmplitudeTracking;
